import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { DOCUMENT } from '@angular/common';
import { SharedSelectors } from '@cp/shared/data-access/+state/selectors';
import { Company, Division } from '@cp/shared/data-access/shared/enums';
import { CompanyService } from '@cp/shared/data-access/company/company.service';
import { StaffDetailsFeatureState } from '@cp/shared/data-access/+state/interfaces/shared.interface';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'cp-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  private readonly _qnUrl = this._companyService.qnUrl('pwa');

  public readonly Division = Division;
  public readonly Company = Company;

  public company = this._companyService.company;

  public user$: Observable<StaffDetailsFeatureState> = this._store.select(
    SharedSelectors.selectStaffDetails,
  );
  public navigationActive$: Observable<boolean> =
    this._headerService.navigationActive$;

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _store: Store,
    private _headerService: HeaderService,
    private _renderer2: Renderer2,
    private _authService: AuthService,
    private _companyService: CompanyService,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}

  public toggleNavigation(): void {
    this._headerService.toggleNavigation(this._renderer2, this._document);
  }

  public closeNavigation(): void {
    this._headerService.closeNavigation(this._renderer2, this._document);
  }

  public logOut(event: MouseEvent | KeyboardEvent): void {
    if (event instanceof KeyboardEvent && event.key !== 'Enter') {
      return;
    }
    this.closeNavigation();
    this._authService.logout({
      logoutParams: { returnTo: this._environment.auth0.logoutUrl },
    });
  }

  public onQuickNurseClick(e: MouseEvent | KeyboardEvent): void {
    if (e instanceof KeyboardEvent && e.key !== 'Enter') return;
    e.stopPropagation();

    window.open(this._qnUrl, '_blank')?.focus();
  }
}
